<template lang="pug" src="./overviewCard.pug"> </template>
<style lang="scss" src="./overviewCard.scss" scoped> </style>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        icon: {
            type: String,
            required: true
        }
    },
    computed: {
        result() {
            return this.value == null ? '-' : this.value
        }
    }
}
</script>
